var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 432V160C21.49 160 0 181.492 0 208V448C0 483.344 28.654 512 64 512H368C394.51 512 416 490.508 416 464H80C62.326 464 48 449.672 48 432ZM448 64H408V24C408 10.75 397.25 0 384 0S360 10.75 360 24V64H248V24C248 10.75 237.25 0 224 0S200 10.75 200 24V64H160C124.654 64 96 92.652 96 128V352C96 387.348 124.654 416 160 416H448C483.346 416 512 387.348 512 352V128C512 92.652 483.346 64 448 64ZM464 352C464 360.824 456.822 368 448 368H160C151.178 368 144 360.824 144 352V192H464V352Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendars);
export default __webpack_public_path__ + "static/media/calendars.2fd30267831062b2ab92a320470f7512.svg";
export { ForwardRef as ReactComponent };